import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'Bordbestilling',
    [ORDER_METHODS.PICKUP]: 'Afhentning',
    [ORDER_METHODS.DELIVERY]: 'Levering',
  },
};
